// extracted by mini-css-extract-plugin
module.exports = {"departments":"Pz","departmentHeading":"Qz","departmentSection":"Rz","departmentName":"Sz","departmentLink":"Tz","expandIcon":"Uz"};